import { post, get } from "../../../../services/request";

// Get Capacity Input Data (supports server-side filtering)
export const getProviderCapacities = async (filterParams = {}) => {
  return post("RadCapacity/GetProviderCapacities", filterParams);
};

// Get Capacity Filter Masters (ProviderList, ProviderTypes, WorkLocations)
export const getProviderCapacityFilters = async () => {
  return get("RadCapacity/GetProviderCapacityFilters");
};

// Get Default RAD Capacity
export const getDefaultRadCapacity = async () => {
  return get("DefaultRadCapacity/GetDefaultRadCapacity");
};

// Update RAD Capacity Input
export const updateRadCapacityInput = async (_updateData) => {
  return post("DefaultRadCapacity/SaveDefaultRadCapacity", _updateData);
};

// Bulk Update RAD Capacity Input
export const bulkUpdateRadCapacityInput = async (_bulkData) => {
  return post("RadCapacity/UpdateProviderCapacities", _bulkData);
};

// Rad Capacity IP Upload
export const radCapacityIpUpload = async (_formData) => {
  return post("RadCapacity/RadCapacityIpUpload", _formData);
};
